//请务必先引入 、Math.uuid.js
//<script src="//res.wx.qq.com/open/js/jweixin-1.2.0.js"></script>  
//<script src="//apps.bdimg.com/libs/jquery/2.1.4/jquery.min.js"></script>
//<script src="//wx2.yutong.com/js/Math.uuid.js"></script>  
//<script src="//wx2.yutong.com/js/md5.min.js"></script>  
//<script src="//wx2.yutong.com/js/wxtool-1.0.1.js?v=5"></script> 
import $ from 'jquery'
//import router from '../../pages/router/index'

function S4() {
   return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
}
function guid() {
   return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4()).replace(/-/g, "")+""+new Date().getTime();;;
}



var basePath=window.location.protocol+"//"+window.location.host;//当前域名
// 
console.log("basePath:"+basePath);// 
//console.log('=>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>basePath>>>>'+basePath);
function  isWxTest(){
	if(basePath.indexOf('127.0.0.1')>=0||basePath.indexOf('192.168.')>=0){
		//console.log('当前属于测试模式'+'=>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>basePath>>>>'+basePath);
		return true;
	}else{
		return false;
	}

}
 isWxTest();

var _wxTool=null;//全局对象，如果链接参数中有wxid=*,将会自动初始化，否则需要自行触发
function WxTool(wxid,ver){
      this.wxid=wxid;
	  this.user=null;
	   this.ver=ver;//版本 

	  this.networkType=null;
	  this.accessId=null;
	  this.shareUrl=null;//分享的url链接
	  
	  
	  this.member=null;//会员基本信息

}//end of fucntion
  
WxTool.prototype.getVer=function(){
	if(null==this.ver||null==undefined.ver) {
		var dv='qmmcv2';
		console.log("the ver is default  "+dv);
		return dv;
	}else{
		
		return this.ver;
	}
	
}


//是否登录
WxTool.prototype.isLogin=function(){
	this.auth();    
	//this.getUser();
    if(null==this.getMember() ){
         console.log('need login');
         return false;
    }else{
    	return true;
    }
    
}


////检查登录状态（通常在个人信息相关页面使用），如果未登陆则，跳转至登陆页面
//WxTool.prototype.loginCheck=function(){
//	this.auth();    
//	//this.getUser();
//  if(null==this.getMember() ){
//       console.log('need login');
//      // try{
//       	    //this.$vux.toast.text('亲，需要先登录哦', 'middle');   会报错
//      // }catche(e){
//       	// console.log("this.$vux.toast.text('亲，需要先登录哦', 'middle')");
//      // }
//       this.$router.push('login')
//  }
//}
WxTool.prototype.getAccessToken=function(){
	 return this.getOpenidToken();
	
}
//获取会员信息（默认从缓存获取）
WxTool.prototype.getMember=function(refresh){
    console.log(isWxTest())
	if(isWxTest()){
	  console.log("返回伪造的会员信息"); 
        console.log(this.getFakeMember())
	  return this.getFakeMember();
    }


 	var curr_obj=this;
	if(undefined==refresh||''==refresh||null==refresh) refresh=false;//（默认从缓存获取）
	
	if(null==this.member) {
		refresh=true;
	}
		
	if(!refresh) {
   	  console.log("直接返回会员信息");
   	  return this.member;
   }else{
        	var openidToken= this.getOpenidToken();
			//console.log("验证是否已经微信授权-openidToken:"+openidToken); 
			// alert("openidToken=="+openidToken);
			var user_tmp=null;
			
		   var url = '/ytqmmc/v2/member/getMemberInfo.thtml?r='+Math.random();	
		   var param={'openidToken':openidToken,'random':Math.random()};
		  // console.log("/ytqmmc/v2/member/getMemberInfo.thtml?:"+openidToken); 
     	 $.ajax({
						type: "POST" ,
						//contentType: "application/json", 默认值: "application/x-www-form-urlencoded"。发送信息至服务器时内容编码类型。
						url: url,
						async:false,//async:false, false 非异步
						data: param , 
						timeout: 30000, //超时时间：30秒
						dataType: 'json',
						error: function (XMLHttpRequest, textStatus, errorThrown){
						     console.log('textStatus：'+textStatus);//js 日志
							//TODO: 处理status， http status code，超时 408
							// 注意：如果发生了错误，错误信息（第二个参数）除了得到null之外，还可能
							//是"timeout", "error", "notmodified" 和 "parsererror"。
						}, 
						success: function(ret) {
							// alert(ret.code);
						     if("0"!=ret.code){//未找到对应的用户信息

								 user_tmp=null;
								 // alert(ret.code+"=="+ret.msg);
								  console.log("会员信息 存在问题:"+ret.code+"=="+ret.msg);
								 
						   }else{
								
								//alert('ok');
								 console.log("ok:"+openidToken);
								//alert(JSON.stringify(ret.data.user));
								 try{
									 user_tmp=ret.data.member;
									 // console.log("成功获取会员信息:");
								 }catch(e){
									 console.log("获取会员信息异常:"+e);
								 }
								 

						   }//end of if-else
						}//end of success
		    });//end of jQuery.ajax
		   //alert("先弹出？");
		    curr_obj.member=user_tmp;
		    return user_tmp;   	
   	
   }
	
}//end of function
/***
返回用户信息 
{
	"authflag": "1",
	"city": "郑州",
	"country": "中国",
	"groupid": 0,
	"headimgurl": "http://thirdwx.qlogo.cn/mmopen/gue5qEaT7ibcSumuLajBvqFCJVbIVTzHA0F7Y0ZaMXtzpcWk1dJUtSQLtKEwhnMe3icLZyao8MDTIGBOT8dLFgtibzLB8iag0Kibt/132",
	"language": "zh_CN",
	"latitude": 0,
	"longitude": 0,
	"nickname": "四味菜",
	"openid": "oDPXUwkUjKZ1hVHA4_qJMFhcu2G4",
	"precision": 0,
	"privilege": [],
	"province": "河南",
	"remark": "",
	"remarkname": "",
	"sex": 1,
	"subscribe": 1,
	"subscribeTime": "2017-06-28 18:26:24",
	"subscribe_time": 1498645584,
	"tagid_list": [],
	"unionid": ""
}

**/

WxTool.prototype.getFakeUser=function(){

	return {
		"authflag": "1",
		"city": "郑州",
		"country": "中国",
		"groupid": 0,
		"headimgurl": "http://wx2.yutong.com/thirdwx/mmopen/mxKxVO0BssQ6GRIdgUQNYicP7QBXtGQYYk4bhz7lYYjhiaHoPcjPxe0cF4rhaF7RWlPz0cqX42A5BS8Qt09icbryUL6ElN9aUu3/132",
		"language": "zh_CN",
		"latitude": 0,
		"longitude": 0,
		"nickname": "四味菜(测试)",
		"openid": "x_xxxxxxxxxxxxxxxxxxxxxxxxxx2",
		"precision": 0,
		"privilege": [],
		"province": "河南",
		"remark": "",
		"remarkname": "",
		"sex": 1,
		"subscribe": 1,
		"subscribeTime": "2017-06-28 18:26:24",
		"subscribe_time": 1498645584,
		"tagid_list": [],
		"unionid": ""
	};
}//end of function
WxTool.prototype.getFakeMember=function(){

	return  {
            "asset": 60001,
            "birthday": "",
            "buycarTime": "2018-08-30",
            "cityArea": null,
            "cityCode": "",
            "clickFav": 0,
            "comefrom": "网裕科技",
            "company": "网裕科技",
            "companyName": "",
            "description": "",
            "email": "",
            "emailVerificationFlag": "",
            "gender": "1",
            "groupId": "",
            "groupName": "",
            "islock": "0",
            "lastDate": "2018-09-12 11:36:48",
            "lastIp": "",
            "loginNum": 1,
            "memberCompany": null,
            "memberDeliveryAddress": null,
            "memberGroup": null,
            "memberGroupList": [],
            "memberPoint": null,
            "msn": "",
            "newEmail": "",
            "nickName": "四味菜",
            "orgName": "",
            "p1": "",
            "p2": "",
            "p3": "",
            "password": "-",
            "phone": "13460434556",
            "phoneValid": 0,
            "photoUrl": "http://thirdwx.qlogo.cn/mmopen/nibiaU76tibbpA97IF3ictM1Ct1zw440rBwZgVLT6FEd72aV5JR7DFAgPvzQtVlFiaGbLbH7GTuPpBBdibBiaCAMRWxaaticZRr8bcu4/132",
            "point": 0,
            "position": "",
            "provinceArea": null,
            "provinceCode": "",
            "qq": "",
            "realname": "本地测试",
            "regIp": "",
            "registerTime": "2018-08-30 17:20:08",
            "registerType": "weixin",
            "registerWay": "weixin",
            "rsetPwdTime": null,
            "tel": "",
            "thirdAccount": "",
            "thirdFlag": 0,
            "thirdName": "",
            "thirdNickname": "",
            "userId": "123",
            "userName": "本地测试"
	};
}//end of function


WxTool.prototype.getUser=function(){
   if(isWxTest()){
	  console.log("返回伪造的用户信息"); 
	
	  return this.getFakeUser();
   }

   
   
   if(null!=this.user) {
   	  console.log("直接返回user信息");
   	  //headimgurl
   	  //http://wx2.yutong.com/thirdwx/mmopen/mxKxVO0BssQ6GRIdgUQNYicP7QBXtGQYYk4bhz7lYYjhiaHoPcjPxe0cF4rhaF7RWlPz0cqX42A5BS8Qt09icbryUL6ElN9aUu3/132
   	  this.user.headimgurl=this.user.headimgurl.replace('http://thirdwx.qlogo.cn','http://wx2.yutong.com/thirdwx').replace("http://",window.location.protocol+"//");//与请求链接地址一致;
   	  return this.user;
   }else{
        	var openidToken= this.getOpenidToken();
			console.log("验证是否已经微信授权-openidToken:"+openidToken); 
			//alert("openidToken=="+openidToken);
			var user_tmp=null;
			
		   var url = '/thtml/v2/wxfront/get-user-info.thtml?r='+Math.random();	
		   var param={'openidToken':openidToken,'random':Math.random()};
		 var curr_obj=this;
     	 $.ajax({
						type: "POST" ,
						//contentType: "application/json", 默认值: "application/x-www-form-urlencoded"。发送信息至服务器时内容编码类型。
						url: url,
						async:false,//async:false, false 非异步
						data: param , 
						timeout: 30000, //超时时间：30秒
						dataType: 'json',
						error: function (XMLHttpRequest, textStatus, errorThrown){
						     console.log('textStatus：'+textStatus);//js 日志
							//TODO: 处理status， http status code，超时 408
							// 注意：如果发生了错误，错误信息（第二个参数）除了得到null之外，还可能
							//是"timeout", "error", "notmodified" 和 "parsererror"。
						}, 
						success: function(ret) {
							//alert(ret.code);
						     if("0"!=ret.code){//重新微信授权

								 user_tmp=null;
								 
						   }else{
								
								//alert('ok');
								 //console.log("ok:"+openidToken);
								//alert(JSON.stringify(ret.data.user));
								 try{
									 user_tmp=ret.data.user;
									 //user_tmp.headimgurl=user_tmp.headimgurl.replace('http://thirdwx.qlogo.cn','http://wx2.yutong.com/thirdwx');
									  user_tmp.headimgurl=user_tmp.headimgurl.replace('http://thirdwx.qlogo.cn','https://wx2.yutong.com/thirdwx');
									  //console.log("成功获取用户信息:");
								 }catch(e){
									 console.log("获取用户信息异常:"+e);
								 }
								 

						   }//end of if-else
						}//end of success
		    });//end of jQuery.ajax
		   //alert("先弹出？");
		    curr_obj.user=user_tmp;
		    return user_tmp;
   	
   	
   }
  
}
/**
     调用方法
	 1.创建对象（创建一次即可） var _wxTool=new  WxTool(wxid);
	 2._wxTool.auth();
	 3.稍后（由于是异步调用）可通过_wxTool.getUser() 获取json用户信息
      
	  检验用户授权情况，如果没授权则根据target 跳转 (可选，默认情况下是当前链接 )
	* @param target (可选，默认情况下是当前链接 )目标链接地址（未编码），如：http://wwww.interentyu.com
	  @param async true 异步（默认）（不会立刻返回值，需要以后根据_wxTool.getUser() 获取 ）, false 非异步，可以直接返回信息
    * @return async==false时方返回信息
*/
WxTool.prototype.auth=function(target,async){
 // alert();

		  if(isWxTest()){
			  console.log("返回伪造的用户信息"); 
			
			  return this.getFakeUser();
		   }

            var retval=null;
            var wxid=this.wxid;

			//console.log("验证是否已经微信授权begin"+wxid  +"&async="+async);
			if(undefined==async||null==async){//||''==async 对于boolen值 false==''
				//console.log("??");
				async=true;
			}
		//	console.log("验证是否已经微信授权begin"+wxid  +"&async="+async);
			var openidToken= this.getOpenidToken();
			//console.log("验证是否已经微信授权-openidToken:"+openidToken); 		 
			
		  var curr_obj=this;

		   var url = '/thtml/v2/wxfront/get-user-info.thtml?r='+Math.random();	
		   console.log("验证是否已经微信授权-openidToken:"+openidToken+"url"+url);
           var param={'openidToken':openidToken,'random':Math.random()};
			var auth_url=this.getAuthUrl(openidToken,target);
		   $.ajax({
						type: "POST" ,
						//contentType: "application/json", 默认值: "application/x-www-form-urlencoded"。发送信息至服务器时内容编码类型。
						url: url,
						async:async,//async:false, false 非异步
						data: param , 
						timeout: 30000, //超时时间：30秒
						dataType: 'json',
						error: function (XMLHttpRequest, textStatus, errorThrown){
						     console.log('textStatus：'+textStatus);//js 日志
							//TODO: 处理status， http status code，超时 408
							// 注意：如果发生了错误，错误信息（第二个参数）除了得到null之外，还可能
							//是"timeout", "error", "notmodified" 和 "parsererror"。
						}, 
						success: function(ret) {
						     if("0"!=ret.code){//重新微信授权
//									alert("重新授权");
								   console.log("auth_url："+auth_url);
								 //alert();
								 //	return;
								  window.location.href=auth_url;
								  retval=false;
								 
						   }else{
								
								//alert('ok');
								 console.log("ok:"+openidToken);
								
								 try{
//								 	alert("用户信息："+ret.data.user);
									 curr_obj.user=ret.data.user;
									 // console.log("成功获取用户信息_wxTool.getUser():"+curr_obj.getUser());
								 }catch(e){
									 console.log("获取用户信息异常:"+e);
								 }
								   retval=true;

								  //console.log("获取会员信息");
								 // curr_obj.getMember();//

						   }//end of if-else
						}//end of success
		    });//end of jQuery.ajax

			if(false==async){
			    console.log('同步调用返回值'+retval);//js 日志
				return 	retval;
			}
       
 };//end of auth



  

/**
     调用方法
	 1.创建对象（创建一次即可） var _wxTool=new  WxTool(wxid);
	 2._wxTool.getAuthUrl(openidToken,target);
	  
      
	  获取授权链接地址
	* @param openidToken 用户token
	  @param target (可选，默认情况下是当前链接 )目标链接地址（未编码），如：http://wwww.interentyu.com
    * @return 授权url地址
*/
WxTool.prototype.getAuthUrl=function(openidToken,target){
			var auth_url=basePath+'/thtml/wxfront/web-auth-get-info2/{openidToken}/{wxid}.thtml?target={target}&r='+Math.random();
			auth_url=auth_url.replace("{wxid}",this.wxid);
			//alert(auth_url);
			var redirect_url=auth_url.replace("{openidToken}",openidToken);
				 
			
			if(null==target||undefined==target||''==target) target=window.location.href;
			//console.log("目标链接是："+target);

			target=encodeURIComponent(target);
			//console.log("目标链接是(编码后)："+target);
			redirect_url=redirect_url.replace("{target}",target);
			console.log("目标链接是："+target+"目标链接是(编码后)："+target+"redirect_url:"+redirect_url);
			return redirect_url;
       
 };//end of getAuthUrl


 /**
     调用方法
	 1.创建对象（创建一次即可） var _wxTool=new  WxTool(wxid);
	 2._wxTool.getOpenidToken();	  
      
	  获取openidToken
    * @return openidToken
*/
WxTool.prototype.getOpenidToken=function(){
		//alert(basePath);
			if(isWxTest()){
				console.log("测试模式，openToken=test"+"basePath:"+basePath);//
				return "test";
			}
			 
			 

			//var openidToken=localStorage.getItem(this.wxid+'@'+this.getVer()+"openidToken",openidToken);// 
			var openidToken=localStorage.getItem(this.wxid+'@'+this.getVer()+"openidToken");// 
		 
			//console.log("old openidToken:"+openidToken);
			//alert("old openidToken:"+openidToken);
			if(undefined==openidToken||null==openidToken||''==openidToken){
					openidToken=this.newOpenidToken(); 
			} 
			console.log("getOpenidToken-openidToken:"+openidToken); 		
			//alert("getOpenidToken-openidToken:"+openidToken);
			return openidToken;
       
 };//end of getOpenidToken

 /**
     调用方法
	 1.创建对象（创建一次即可） var _wxTool=new  WxTool(wxid);
	 2._wxTool.newOpenidToken();
	 
	 重新创建 openidToken
	 @return openidToken
*/
WxTool.prototype.newOpenidToken=function(){
   // return 'test';
			//var openidToken=this.wxid+'@'+Math.uuidFast().replace(/-/g, "")+""+new Date().getTime();//token 中不能有-
			if(isWxTest()) return "test";
			
			var openidToken=guid();
			localStorage.setItem(this.wxid+'@'+this.getVer()+"openidToken",openidToken);// 	
			console.log("new openidToken:"+openidToken); 		
			return openidToken;
       
 };//end of getOpenidToken

 WxTool.prototype.getAccessId=function(){
 			return 'accessId';//暂时不使用
//			var id=md5(this.wxid+'@'+new Date().getTime());// 
//			console.log("md5:"+id); 	
//			id=id+Math.uuidFast().replace(/-/g, "");
//			console.log("getAccessId:"+id); 				 
//		 
//			return id;
       
 };//end of getAccessId


  /**
     调用日志，仅有链接中包含docId时才可以调用
	 1.创建对象（创建一次即可） var _wxTool=new  WxTool(wxid);
	 2._wxTool.log();	  
      
	   
    * @return 访问id
*/
WxTool.prototype.log=function(sourceId,url){
			 
       //	console.log("=====》log 被调用: "+url);
 };//end of  function

  
 
 /**
     调用方法
	 1.创建对象（创建一次即可） var _wxTool=new  WxTool(wxid);
	 2._wxTool.setShare(imgUrl,document.title,content);
	  
      
	  设置分享链接，并创建日志
	* @param imgUrl 分享图片地址
	  @param title 分享标题地址(非必填，默认为当前标题)
	  @param content 分享内容(非必填)
    * @return 分享url（非必填，默认为当前url，且自动添加enterId）
	  @return logFlag 是否需要日志，0-不需要 1- 需要（默认需要）
*/
WxTool.prototype.setShare=function(imgUrl,title,content,url,logFlag){
			if(undefined==imgUrl||null==imgUrl||''==imgUrl){
				   imgUrl= 'https://imgwww.yutong.com/image/weixinshare.jpg';
			}
			if(undefined==title||null==title||''==title){
				   title = document.title;//宇通客车全民营销
			 }

			 if(undefined==content||null==content||''==content){
			 	content='';
//			 	var meta = document.getElementsByTagName('meta');
//			   
//			 	for(var i=0;i<meta.length;i++){
//					 if(typeof meta[i].name!="undefined"&&meta[i].name.toLowerCase()=="description"){
//						  content = meta[i].content;
//					 }
//				}
				content='宇通推广大使是宇通客车打造的社会化营销推荐平台，只要有手机，就能轻松获取奖励。';
				
			 }
			  if(undefined==logFlag||null==logFlag||''==logFlag){
			 	 //logFlag=1;
				  //console.log("需要日志");
			 }
			   //console.log("logFlag="+logFlag);


			 if(undefined==url||null==url||''==url){
				 url=window.location.href;//使用当前url为分享链接

			 }
			 //vue 防止分享失效
			 //https://wx2.yutong.com/2018qmmc/#/productDatail/?productId=2015ISQszjna2I 变为
			 ///https://wx2.yutong.com/2018qmmc/?#/productDatail/?productId=2015ISQszjna2I (#添加?)
			 if(url.indexOf("#") > 0) {
			 		var url_index=url.indexOf("#");
			 	    url=url.substring(0,url_index)+"?"+url.substring(url_index,url.length)
			 }
			 
			 
			 
			 this.shareUrl=url;//分享的url链接
			 //解析enterId

			 var weione_share_url=basePath+'/thtml/wxinterface/JSSDK-share/{wxid}.thtml?rr='+Math.random();
			 
			 weione_share_url=weione_share_url.replace("{wxid}",this.wxid);
			 // String title,String imgUrl,String url,String content,
			 weione_share_url+="&title="+title;
			 weione_share_url+="&imgUrl="+encodeURIComponent(imgUrl);
			 weione_share_url+="&url="+encodeURIComponent(url);
			 weione_share_url+="&content="+content;

			 var wxtool2=this;
			  $.getScript(weione_share_url, function() {
				  console.log("Load JSSDK-share  was performed.");
				  

		
			 });
       
 };//end of setShare
 
 /**
     调用方法
	 1.创建对象（创建一次即可） var _wxTool=new  WxTool(wxid);
	 2._wxTool.setNoShare();
	  
*/
WxTool.prototype.setNoShare=function(logFlag){
  		 
  		 
			 this.setShare('','','','https://wx2.yutong.com/tgds/');//直接到首页
			 return;
			 
			  if(undefined==logFlag||null==logFlag||''==logFlag){
			 	 logFlag=1;
				  console.log("需要日志");
			 }
			 //  console.log("logFlag="+logFlag);

		 
		    
			 var  url=window.location.href;//使用当前url为分享链接

			 

			 var weione_share_url=basePath+'/thtml/wxinterface/JSSDK-noshare/{wxid}.thtml?rr='+Math.random();
			 weione_share_url=weione_share_url.replace("{wxid}",this.wxid);

			// var sourceId=this.getUrlParam(url,"enterId");//原enterId，现在是sourceId
			// var accessId=this.getAccessId();//新的enterId
			// url=this.createShareUrl(accessId,window.location.href);
			 

			 var wxtool2=this;
//			  $.getScript(weione_share_url, function() {
//				  console.log("Load share was performed.");
//				 
//
//		
//			 });
}//end of function
 
     
WxTool.prototype.getUrlParam=function(url,name) {		 
		url=url.substring(url.indexOf("?")+1,url.length);
        //alert(url);
		for(var i=0;i<url.split("&").length;i++){
			var p=url.split("&")[i].replace("#","");
			var n=p.split("=")[0];
			var v=p.split("=")[1];
			// alert(name+"="+v);
			//if(n==name) return v;
			if(n==name) return decodeURIComponent(v);
	
		}
		return '';
};//end of  function


WxTool.prototype.downloadImage=function(serverId) {		
		//alert('XlDYtTOKpjuAIm32zo6jjRM29Kqpe3ztMZk5c6VCahPhoL1g9v3GqdyKAKXOOVwn');
		wx.downloadImage({
			serverId: serverId, // 需要下载的图片的服务器端ID，由uploadImage接口获得
			isShowProgressTips: 1, // 默认为1，显示进度提示
			success: function (res) {
			var localId = res.localId; // 返回图片下载后的本地ID
			}
		});
};//end of  function
WxTool.prototype.previewImage=function(current,urls) {		
		if(undefined==urls||''==urls||null==urls){
			urls = new Array()
			urls[0] = current;
		}
		console.log(current,urls)
		wx.previewImage({
			current: current, // 当前显示图片的http链接
			urls: urls // 需要预览的图片http链接列表
		});
};//end of  function

/**
 * 获取访客ID（unique visitor）
 */
WxTool.prototype.getUVId=function(){
	 
			 
			var key=this.wxid+'@'+this.getVer()+"UVId";
			var UVId=localStorage.getItem(key);// 
		  
			if(undefined==UVId||null==UVId||''==UVId){
					UVId="UVId"+guid().substring(0,32);
					localStorage.setItem(key,UVId);// 	
					console.log("create UVId:"+UVId);
			} 
			 
			//alert("getOpenidToken-openidToken:"+openidToken);
			return UVId;
       
 };//end of getUVId
 
 
export default WxTool

 




 



// WEBPACK FOOTER //
// ./src/base/js/wxtool-qmmc.js